export default "__VITE_ASSET__DnZTLAHS__"